import React, { Dispatch, FC, SetStateAction } from 'react';
import { useSearchParams } from 'next/navigation';
import { useRouter, usePathname } from '@/navigation';
import { ShopifyVariant } from '@/lib/shopify';
import styles from '@/components/ui/Select/Select.module.scss';
import { ProductVariantCopy } from '@/lib/contentful';
import { getVariantTranslation } from '@/utils/getVariantTranslation';

interface VariantDropdownInterface {
  variants: ShopifyVariant[];
  selectedVariant: ShopifyVariant;
  cb: Dispatch<SetStateAction<ShopifyVariant>>;
  name: string;
  id: string;
  productVariantsCopy: ProductVariantCopy | null;
}

const VariantDropdown: FC<VariantDropdownInterface> = ({
  name,
  id,
  variants,
  selectedVariant,
  cb,
  productVariantsCopy,
}) => {
  const { push } = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams(); // This hook is read-only
  const searchParamsObj: Record<string, string> = {};
  searchParams?.forEach((value, key) => (searchParamsObj[key] = value));
  const params = new URLSearchParams(searchParamsObj);

  const handleOnChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const productString = event.currentTarget.value;
    const variantId = productString.split('gid://shopify/ProductVariant/')[1];
    const variant = variants.filter((v) => v.id === productString)[0];
    params.set('variant', variantId);
    push(`${pathname}?${params.toString()}`);
    cb(variant);
  };

  return (
    <div className="mb-3 max-w-[360px] md:mb-4 md:max-w-[240px]">
      <p className="text-base mb-1">
        {getVariantTranslation(productVariantsCopy, 'Language')}:
      </p>
      <select
        name={name}
        id={id}
        onChange={handleOnChange}
        value={selectedVariant.id}
        className={`select w-full rounded-sm border border-grey-midtone text-lg ${styles.select}`}
      >
        {variants.map((v: ShopifyVariant) => {
          const title = getVariantTranslation(productVariantsCopy, v.title);
          return (
            <option key={v.id} value={v.id}>
              {title}
            </option>
          );
        })}
      </select>
    </div>
  );
};

export default VariantDropdown;
